import {useEquipmentStatus as useDomainEquipmentStatus} from '@domain/kpis'
import {AxiosError} from 'axios'
import {useCallback} from 'react'
import {useNavigate} from 'react-router'

import {handleError} from '../helpers'

type Params = Parameters<typeof useDomainEquipmentStatus>

export const useEquipmentStatus = (
  timeRange: Params[0],
  hierarchyId?: Params[1],
  options?: Params[2]
) => {
  const navigate = useNavigate()
  const onError = useCallback((error: AxiosError) => handleError(error, navigate), [navigate])

  return useDomainEquipmentStatus(timeRange, hierarchyId, {onError, ...options})
}
